<div class="price-guides-index-page">
  <app-breadcrumb-list [partsOfUrl]="partsOfUrl"></app-breadcrumb-list>

  <div class="tips-index-header">
    <h1>
      {{ 'PAGES.AI_PRICE_GUIDES_INDEX.H1_PREFIX' | translate }}
      {{ activeCategoryTitle }}
    </h1>
    <p>
      {{ 'PAGES.AI_PRICE_GUIDES_INDEX.INTRO_PART_1' | translate }}
      {{ activeCategoryTitle
      }}{{ 'PAGES.AI_PRICE_GUIDES_INDEX.INTRO_PART_2' | translate }}
    </p>
  </div>

  <div class="tips-index-content">
    @if (loadingPriceGuides) {
      <div class="loading-indicator">
        <p>{{ 'PAGES.AI_PRICE_GUIDES_INDEX.LOADING' | translate }}</p>
      </div>
    } @else if (aiPriceGuides.length === 0) {
      <div class="no-guides">
        <p>{{ 'PAGES.AI_PRICE_GUIDES_INDEX.EMPTY' | translate }}</p>
      </div>
    } @else {
      <div class="guides-grid">
        @for (guide of aiPriceGuides; track guide._id) {
          <div class="guide-card">
            <a [routerLink]="getPriceGuideUrl(guide)">
              @if (guide?.heroImg) {
                <div class="guide-image">
                  <img
                    [ngSrc]="guide.heroImg!"
                    [alt]="guide.title"
                    width="320"
                    height="180"
                    loading="lazy"
                    [priority]="false"
                  />
                </div>
              }
              <div class="guide-content">
                <h2>{{ guide.title }}</h2>
                @if (guide.answer) {
                  <p class="guide-description">
                    {{ guide.answer | slice: 0 : 120 }}...
                  </p>
                }
                @if (guide.price_guide) {
                  <div class="price-range">
                    <mat-icon>payments</mat-icon>
                    <span>{{
                      guide.price_guide.min
                        | formatCurrencyRange: guide.price_guide.max
                    }}</span>
                  </div>
                }
              </div>
            </a>
          </div>
        }
      </div>
    }
  </div>
</div>

@if (breadCrumSchema) {
  <div [innerHTML]="breadCrumSchema | jsonLd"></div>
}
